import React, { useState } from "react";
import { Form, Row, Col, Container } from "react-bootstrap";
import PropTypes from 'prop-types';
import { object, string, mixed } from 'yup';
import { CheckboxInput, TextInput } from "../../../Helpers/Inputs";
import { InputMaskDate, InputMaskSSN } from '../../../Helpers/Formatters';
import { Dialog, DialogContent, IconButton, Button, makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import moment from 'moment';
import { ConvertStringToBoolean, ConvertBooleanToString } from "../../../Helpers/Formatters/ConvertBoolean";
import { customValidators } from "../../../Helpers/Validators/customValidators";
import Alert from '@material-ui/lab/Alert';
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';
import GenerateUniqueSSN from '../../../Helpers/Prefill/GenerateUniqueSSN';
import { getStateSpecificFormNumber } from "../Helpers/AgreementToUnderwritingData";

const useStyles = makeStyles(theme => ({
  colorPrimary: {
    color : theme.palette.primary.main,
  },
  bgColor:{
    backgroundColor: `${theme.palette.primary.main}16`,
  }  
}));

export default function AgreementToUnderwriting(props) {

  const { register, errors } = props;

  const nameOfProposedInsured = props.formState.nameOfProposedInsured !== undefined ?
    props.formState.nameOfProposedInsured :
    `${props.fullFormState.steps.personalInfo.firstName}${props.fullFormState.steps.personalInfo.middleInitial ? ` ${props.fullFormState.steps.personalInfo.middleInitial}` : ''} ${props.fullFormState.steps.personalInfo.lastName}`;

  const classes = useStyles();

  const [creditDialogOpen, setCreditDialogOpen] = useState(false);

  function CreditLockDialog(props) {
    return (
      <div>
        <Dialog className="credit-dialog" maxWidth="md" open={props.open} onClose={props.onCreditDialogClosed} scroll="body">
          <DialogContent className="product-info-dialog-content">
            <IconButton className="product-info-close-button" aria-label="close" onClick={props.onCreditDialogClosed}>
              <CloseIcon />
            </IconButton>
            <Row className="justify-content-center text-center">
              <Col lg={9}>
                <span className="span-title">Have you frozen your credit with TransUnion?</span>
                <p className="desc">
                  If you have chosen to "lock" or "freeze" your credit, this will result in an automatic decline. To continue, unfreeze or unlock your credit to apply.
                </p>
                <p className="subtitle">Your credit will not be pulled or affected in any way.</p>
                <a href="https://www.transunion.com/credit-freeze" className="link" target="_blank" rel="noopener noreferrer">https://www.transunion.com/credit-freeze</a>

                <Row className="justify-content-center">
                  <Form.Group>
                    <Button variant="contained" color="primary" onClick={props.onCreditDialogClosed} fullWidth>Continue</Button>
                  </Form.Group>
                </Row>
              </Col></Row>
          </DialogContent>
        </Dialog>
      </div>
    );
  }

  function DisclosureDialog(props) {
    return (
      <div>
        <Dialog maxWidth="md" open={props.open} onClose={props.onDisclosureDialogClosed} scroll="body">
          <DialogContent className="product-info-dialog-content">
            <IconButton className="product-info-close-button" aria-label="close" onClick={props.onDisclosureDialogClosed}>
              <CloseIcon />
            </IconButton>
            {props.component}
          </DialogContent>
        </Dialog>
      </div>
    );
  }

  return (
    <Container>
      <Row className="formPage mt-0 justify-content-center">
        <Col lg={7}>
        <p className="text">Form Numbers: {getStateSpecificFormNumber(props.basicInfo.state)}</p>
        </Col>
        <Col lg={6}>
          <Row className="justify-content-center">
            <Col lg={9}>
              <Form.Group className="mb-0">
                <CheckboxInput
                  name="agreedToUnderwritingTerms"
                  id="agreedToUnderwritingTerms"
                  checked={ConvertStringToBoolean(props.formState.agreedToUnderwritingTerms)}
                  onChange={e => props.onFieldChange('agreedToUnderwritingTerms', ConvertBooleanToString(e.target.checked))}
                  errors={errors.agreedToUnderwritingTerms}
                  inputRef={register}
                  label="I have read and agreed to these terms."
                />
              </Form.Group>

              <Form.Group>
                <TextInput
                  id="nameOfProposedInsured"
                  name="nameOfProposedInsured"
                  value={nameOfProposedInsured}
                  onChange={e => props.onFieldChange('nameOfProposedInsured', e.target.value)}
                  errors={errors.nameOfProposedInsured}
                  inputRef={register}
                  label="Name of Proposed Insured"
                />
              </Form.Group>

              <Form.Group>
                <TextInput
                  name="socialSecurityNumber"
                  id="socialSecurityNumber"
                  label="Social Security Number"
                  value={props.formState.socialSecurityNumber}
                  onChange={e => props.onFieldChange('socialSecurityNumber', e.target.value)}
                  errors={errors.socialSecurityNumber}
                  inputRef={register}
                  InputProps={{
                    inputComponent: InputMaskSSN,
                  }}
                />
              </Form.Group>

              <Alert className={`mt-3 mb-3 ${classes.bgColor}`} icon={false} >
                <EmojiObjectsIcon color="primary"/> <span className={`${classes.colorPrimary}`}> Insider Tip: </span> Asking for a SSN is a standard industry practice to verify your identity, give you the most accurate rate and prevent fraudulent applications.
              </Alert>

              <h6>Type your name to sign digitally</h6>

              <Form.Group>
                <TextInput
                  id="signatureOfProposedInsured"
                  name="signatureOfProposedInsured"
                  value={props.formState.signatureOfProposedInsured}
                  onChange={e => props.onFieldChange('signatureOfProposedInsured', e.target.value)}
                  errors={errors.signatureOfProposedInsured}
                  inputRef={register}
                  label="Signature of Proposed Insured"
                />
              </Form.Group>

              <Form.Group>
                <TextInput
                  id="dateOfSigning"
                  name="dateOfSigning"
                  value={props.formState.dateOfSigning}
                  onChange={e => props.onFieldChange('dateOfSigning', e.target.value)}
                  errors={errors.dateOfSigning}
                  label="Date of Signing"
                  inputRef={register}
                  InputProps={{
                    inputComponent: InputMaskDate,
                  }}
                />
              </Form.Group>

              <Form.Group>
                <p className="text mt-3 mb-0">If you have locked your credit with transunion click here.</p>
                <Button variant="text" color="primary" onClick={() => { setCreditDialogOpen(true); }}>HOW TO UNLOCK YOUR CREDIT</Button>
              </Form.Group>

            </Col>
          </Row>
        </Col>
      </Row>
      <CreditLockDialog
        open={creditDialogOpen}
        onCreditDialogClosed={() => {
          setCreditDialogOpen(false);
        }}
        onNext={props.onNext}
      />
      <DisclosureDialog
        open={props.disclosureDialogOpen}
        onDisclosureDialogClosed={() => {
          props.setDisclosureDialogOpen(false);
        }}
        component={props.component}
      />
    </Container>
  );
}

AgreementToUnderwriting.propTypes = {
  formState: PropTypes.object.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  register: PropTypes.func,
  errors: PropTypes.object,
  fullFormState: PropTypes.object,
  component: PropTypes.func,
  basicInfo: PropTypes.object,
  onNext: PropTypes.func,
  disclosureDialogOpen: PropTypes.bool,
  setDisclosureDialogOpen: PropTypes.func,
};

AgreementToUnderwriting.ValidationSchema = object().shape({
  agreedToUnderwritingTerms: mixed().notRequired(),
  nameOfProposedInsured: customValidators.string().isValidNameLimitedSpecialChar('Name of Proposed Insured is required.', true, false),
  signatureOfProposedInsured: customValidators.string().isValidNameLimitedSpecialChar('Signature of Proposed Insured is required.', true, false),
  dateOfSigning: string().required('Date of Signing is required.'),
  socialSecurityNumber: string()
    .required('Social Security Number is required.')
    .matches(/^[0-8]/, 'Coverage is not available due to citizenship status.')
    .matches(/(^(?:\d{3}-?\d{2}-?\d{4})?$)/, 'Social Security Number must be formatted as "123-45-6789".'),
});

AgreementToUnderwriting.DefaultFormState = (prefill = false) => {
  const ssn = GenerateUniqueSSN('555');
  return {
    agreedToUnderwritingTerms: prefill ? "true" : "false",
    signatureOfProposedInsured: prefill ? 'Proposed N Sured' : '',
    dateOfSigning: moment(new Date()).format("MM/DD/YYYY"),
    socialSecurityNumber: prefill ? ssn : "",
  };
};



// WEBPACK FOOTER //
// ./src/components/Quoters/AmericoLoanProtection/steps/AgreementToUnderwriting.js